const version = '__VERSION__'
import {
  $oauth2,
  removeRefreshToken,
  removeAccessToken,
  hasRefreshToken,
  hasAccessToken,
  getRefreshToken,
  getAccessToken,
  isGuest
} from './oauth2/oauth2.js'
const cookie = require('./utils/cookie.js')
const storage = require('./utils/storage.js')
import {getHost, getRedirectUrl, redirectAuthUrl, handleAuthQuery} from './oauth2/handle-oauth2.js'
import {encodeComponent, b64Encode} from './utils/encoding.js'
import {$fetch} from "./fetch-api/fetch-api.js"
import {$error, handleError, handleResponse} from "./fetch-api/handle-error.js"

const VuePlugin = {
  install: (Vue, options) => {
    const oauth2 = new Vue({
      data: {
        expires: $oauth2.expires,
        appURL: $oauth2.appURL,
        cookie: cookie,
        storage: storage
      },
      methods: {
        removeRefreshToken,
        removeAccessToken,
        hasRefreshToken,
        hasAccessToken,
        getRefreshToken,
        getAccessToken,
        getHost,
        getRedirectUrl,
        redirectAuthUrl,
        handleAuthQuery,
        encodeComponent,
        b64Encode,
        isGuest
      }
    })
    const error = new Vue({
      data: {
        error: $error.error
      },
      computed: {
        hasStatus: {
          get() {
            return !!$error.error.status
          }
        },
        alertResponse: {
          get() {
            return this.hasStatus ? 'response' + $error.error.status : null
          }
        },
        dialogResponse: {
          get() {
            return this.hasStatus ? 'response' + $error.error.status : null
          }
        },
        errorText: {
          get() {
            return $error.error.messages && $error.error.messages.length > 0 ? $error.error.messages[0].error : ''
          }
        },
        scopeText: {
          get() {
            return $error.error.messages && $error.error.messages.length > 0 ? $error.error.messages[0].error : ''
          }
        }
      },
      methods: {
        handleError,
        handleResponse
      }
    })
    Vue.prototype.$oauth2 = oauth2
    Vue.prototype.$error = error
    Vue.prototype.$fetch = $fetch
  },
  version
}

export default VuePlugin

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VuePlugin)
}
